<ndt-add-time-based-route-view
   [callState]="callState | async"
   [form]="form"
   [extension]="extension"
   [title]="title"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-time-based-route-view>
